module.exports = __webpack_public_path__ + "static/img/csss.bc7aad4e.jpg";